export default __webpack_public_path__ + "static/media/transparent.a9d72780.png";